import { Accessor, createContext, JSX, useContext } from "solid-js";
import { HomeV3RouteData } from "../data/home_v3_route_data";
import { useHomeV3 } from "../hooks/useHomeV3";

export type HomeV3ContextValue = {
  routeData: Accessor<HomeV3RouteData>;
  onBrandClick: (brandKey: string) => void;
} & ReturnType<typeof useHomeV3>;

const HomeV3Context = createContext<HomeV3ContextValue>();

export function useHomeV3Context() {
  const context = useContext(HomeV3Context);
  if (!context) {
    throw new Error("useHomeV3Context must be used within HomeV3Provider");
  }
  return context;
}

export function HomeV3Provider(props: {
  children: JSX.Element;
  value: HomeV3ContextValue;
}) {
  return (
    <HomeV3Context.Provider value={props.value}>
      {props.children}
    </HomeV3Context.Provider>
  );
}
